<template>
  <div style="width: 100%">
    <div :id="id" :style="{ width: '100%', height: '500px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "pie-statistics-modular",
  data () {
    return {}
  },
  props: {
    title: {
      type: String
    },
    id: {
      type: String,
    },
    month: {
      type: Array,
    },
    increase: {
      type: Array,
    },
    reduce: {
      type: Array,
    },
    outData:{
      type: Array,
    },
    total: {
      type: Array,
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'bar'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        legend: {
          data: ['整体数量','续费数量','到期数量',  '退会数量',],
          // textStyle: {
          //   'color': '#fff'
          // }
        },
        xAxis: [
          {
            type: 'category',
            data: this.month,
            axisPointer: {
              type: 'shadow'
            },
            nameTextStyle: {
              'color': '#fff'
            },
            axisLabel:{
              interval:0,
              rotate:40,
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
              minInterval: 1,
            name: '数量',
          },


        ],
        series: [
          {
            name: '整体数量',
            type: 'line',
            label: {
              show: true,
              position: 'top'
            },

            data: this.total
          },
          {
            name: '续费数量',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: this.reduce
          },
          {
            name: '到期数量',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: this.increase
          },

          {
            name: '退会数量',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              color: '#a90000'
            },
            data: this.outData
          },

        ]
      });
    }
  },
  watch: {
    total () {
      this.drawLine();
    }
  }
}
</script>

<style scoped lang="scss">
.title-warpper {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 16px;

  .title-text {
    color: #667fa0;

    i {
      font-size: 20px;
      margin-right: 10px;
    }
  }
  .wecome {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    span {
      color: #0d7fd7;
    }
  }
}
</style>